import styled from 'styled-components';

import { theme } from '@/lib';

const Select = styled.div`
  ._dark & {
    &.form-item-select .form-item-input {
      &:active {
        border-color: ${theme.clientColor.third};
      }
      &.selecting {
        border-color: ${theme.clientColor.third};
      }
    }
    .form-item-options {
      background: #464d55;
      .item {
        color: #fff;
        background: #464d55;
        &:not(.disabled):hover {
          background: #525b64;
        }
        &.disabled {
          color: #888;
        }
      }
      .active {
        color: #fff;
        background: #525b64;
        &::after {
          display: none;
        }
      }
    }
  }

  .layout-inline & {
    .form-item-options {
      top: 38px;
      left: 54px;
      width: 374px;
    }
  }

  &.form-item-select-multi {
    .form-item-input {
      min-height: 36px;
      height: auto;
      align-items: flex-start;
      &:after {
        margin: 10px 0 0 10px;
      }
    }
    .form-item-input-inner {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      justify-content: flex-start;
      padding: 6px;
      margin: 0 -6px;
      grid-gap: 6px;
      span {
        height: 24px;
        line-height: 24px;
        padding: 0 6px;
        border-radius: 4px;
        background-color: #efefef;
        max-width: 100px;
        &:hover {
          i {
            display: inline-block;
          }
        }
        i {
          display: none;
          font-style: normal;
          font-size: 12px;
          line-height: 1;
        }
      }
    }
  }

  .form-item-input {
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: space-between;
    &:active {
      border-color: ${theme.color.primary};
    }
    &.selecting {
      border-color: ${theme.color.primary};
    }
    &.placeholder {
      color: #d6d6d6;
    }
    &:after {
      content: '';
      display: block;
      width: 16px;
      height: 16px;
      flex: 0 0 16px;
      background: url(${require('../images/icon-down.png')}) no-repeat center /
        contain;
    }
  }

  .list-empty {
    padding: 0 0 30px;
    .img {
      background-size: 120px 120px;
      height: 100px;
    }
  }

  .form-item-options {
    position: absolute;
    z-index: 3;
    top: 68px;
    left: 1px;
    border-radius: 4px;
    width: 378px;
    user-select: none;
    max-height: 210px;
    height: auto;
    background-color: #fff;
    box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.1);
    .item {
      box-sizing: border-box;
      padding: 0 12px;
      height: 30px;
      line-height: 30px;
      cursor: pointer;

      &:not(.disabled):hover {
        background-color: #f2f2f2;
      }
    }
    .active {
      color: ${theme.color.primary};
      display: flex;
      align-items: center;
      justify-content: space-between;
      &:after {
        content: '';
        display: block;
        width: 16px;
        height: 16px;
        background: url(${require('../images/icon-check.png')}) no-repeat center /
          contain;
      }
    }

    .disabled {
      background-color: #e3e3e3;
      color: #919191;
      cursor: not-allowed;
    }
  }
`;

export default {
  Select,
};
